import React from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';

function DownloadPdfModal({showDownloadPdfModal, setShowDownloadPdfModal, downloadPdfModalDetails}) {

    const navigate = useNavigate();

    const onchangeTerm = (event) => {
      const details = {admissionNumber: downloadPdfModalDetails.admissionNumber, term:(event.target.value+" Fee"), academicYear: downloadPdfModalDetails.academicYear}
      navigate('/offlinePaymentStatus', { state: details })
    }

  return (
    <Modal size="md" show={showDownloadPdfModal} onHide={() => { setShowDownloadPdfModal(!showDownloadPdfModal) }}  scrollable>
            <Modal.Header closeButton>
                <Modal.Title> <p style={{padding:0, margin:0, color:"#333333", fontFamily:["Helvetica", "sans-serif"], fontSize:"20px"}}>Select Term</p></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <select style={{ backgroundImage: 'none' }} placeholder="Select the Term" onChange={onchangeTerm} className="form-control mb-3" aria-label="Default select example">
                        <option disabled selected hidden value="" >Select The Term</option>
                        {downloadPdfModalDetails?.termsList?.map((each,i) => {
                            return <option key={i} value={each}>{each}</option>
                        })}
                    </select>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => { setShowDownloadPdfModal(false) }}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
  )
}

export default DownloadPdfModal